import React from 'react'

const Subtitle = ({ text }) => {
    return (
        <div className="question">
            <h2 className="questionTitle">
                {/* {text} */}
                {text.split('\n').map( (it, i) => <div key={'x'+i}>{it}</div> )}
            </h2>
        </div>
    )
}



export default Subtitle

